export default {
  data() {
    return {
      currentSlide: 0
    };
  },
  methods: {
    handleBeforeSwipe(oldSlide, newSlide) {
      // Update dots position before the carousel moves
      this.currentSlide = newSlide;
      this.centerActiveDot();
    },
    handleSwipe(currentSlide) {
      this.currentSlide = currentSlide;
      this.centerActiveDot();
      this.$emit("after-change");
    },
    centerActiveDot() {
      // Fixed position dots with responsive width
      this.$nextTick(() => {
        // Scope to this component's own DOM so multiple carousels on the
        // same page each size and centre their own dots.
        const root = this.$el;
        if (!root) return;
        const dotsList = root.querySelector(".slick-dots");
        const carousel = root.querySelector(".slick-slider");

        if (dotsList && carousel) {
          const allDots = Array.from(dotsList.querySelectorAll("li"));
          const totalDots = allDots.length;
          const maxDots = 8;
          const visibleDots = Math.min(totalDots, maxDots);

          // Get carousel width
          const carouselWidth = carousel.offsetWidth;
          const gapSize = 10; // 10px gap between dots
          const totalGapWidth = (visibleDots - 1) * gapSize;
          const availableWidth = carouselWidth - totalGapWidth;
          const dashWidth = availableWidth / visibleDots;

          // Show all dots up to max 8, hide the rest
          allDots.forEach((dot, index) => {
            if (index < maxDots) {
              dot.classList.remove("dot-hidden");
              dot.style.display = "flex";
              // Set dynamic width for each dash
              const button = dot.querySelector("button");
              if (button) {
                button.style.width = dashWidth + "px";
              }
            } else {
              dot.classList.add("dot-hidden");
              dot.style.display = "none";
            }
          });

          // Keep dots centered and fixed, fill carousel width
          dotsList.style.setProperty("left", "50%", "important");
          dotsList.style.setProperty("width", carouselWidth + "px", "important");
          dotsList.style.setProperty("transform", "translateX(-50%)", "important");
        }
      });
    },
    getArrowConfig() {
      // Returns the arrow configuration for Slick
      return {
        nextArrow:
          '<div class="slick-arrow-next bottom-arrow">' +
          '<a class="slick-arrow-container std-arrow-container"><i class="fas fa-chevron-right text-white fa-4xs"></i></a>' +
          "</div>",
        prevArrow:
          '<div class="slick-arrow-prev bottom-arrow">' +
          '<a class="slick-arrow-container std-arrow-container"><i class="fas fa-chevron-left text-white fa-4xs"></i></a>' +
          "</div>"
      };
    },
    injectCarouselStyles() {
      // Only inject once to avoid duplicates
      if (document.getElementById('carousel-arrows-dots-styles')) {
        return;
      }

      const style = document.createElement('style');
      style.id = "carousel-arrows-dots-styles";
      style.textContent = `
        /* Arrow styling */
        .slick-track {
          display: flex !important;
        }
        .slick-arrow-container {
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 300px;
          line-height: 0;
          padding: 0;
          height: 100%;
        }

        .std-arrow-container {
          background-color: rgba(0, 0, 143, 0.95) !important;
          width: 60px !important;
          height: 60px !important;
          border-radius: 50% !important;
          padding: 0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          border: 2px solid white !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
        }

        .std-arrow-container i {
          color: white !important;
          font-size: 24px !important;
        }

        .slick-slider {
          position: relative;
          padding-bottom: 130px;
        }

        .no-controls .carousel-pause-btn {
          display: none !important;
        }

        .no-controls .bottom-arrow {
          display: none !important;
        }

        .no-controls .slick-dots {
          display: none !important;
        }

        .no-controls .slick-slider {
          padding-bottom: 0;
        }

        .slick-list {
          margin-bottom: 0;
          overflow: visible;
        }

        .bottom-arrow {
          position: absolute;
          bottom: 30px;
          right: 10px !important;
          left: auto !important;
          top: auto !important;
          background-color: transparent;
          border: none;
          z-index: 20;
          width: auto !important;
          height: auto !important;
          transform: none !important;
        }

        .bottom-arrow.slick-arrow-prev {
          right: 90px !important;
          @media (max-width: 768px) {
            right: 50px !important;
          }
        }

        .bottom-arrow.slick-arrow-next {
          right: 0 !important;
        }

        .bottom-arrow:disabled,
        .bottom-arrow.slick-disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        /* Dots styling */
        .slick-dots {
          padding: 0 !important;
          position: absolute;
          bottom: 17% !important;
          left: 50% !important;
          transform: translateX(-50%);
          display: flex !important;
          justify-content: flex-start;
          align-items: center;
          gap: 10px;
          width: 100% !important;
          margin: 0 !important;
          z-index: 15 !important;
        }

        .slick-dots li {
          display: flex;
          align-items: center;
          justify-content: center;
          width: auto;
          height: 10px;
          margin: 0;
          padding: 0;
          list-style: none;
          flex: 1 1 auto;
          min-width: 0;
        }

        .slick-dots li.dot-hidden {
          display: none !important;
          width: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
        }

        .slick-dots li button {
          width: 100%;
          height: 10px;
          padding: 0;
          border-radius: 10px;
          background-color: #9e9e9e;
          border: none;
          opacity: 1;
          font-size: 0;
          line-height: 0;
          text-indent: -9999px;
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .slick-dots li.slick-active button {
          background-color: rgba(0, 0, 143, 0.95) !important;
          width: 100%;
          height: 10px;
        }

        /* Mobile adjustments */
        @media (max-width: 768px) {
          .std-arrow-container {
            width: 44px !important;
            height: 44px !important;
          }

          .std-arrow-container i {
            font-size: 18px !important;
          }

          .slick-dots {
            bottom: 14% !important;
          }

          .slick-slider {
            padding-bottom: 100px;
          }
        }
      `;
      document.head.appendChild(style);
    }
  },
  mounted() {
    this.injectCarouselStyles();
  }
};
